export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.products": "Products",
  "nav.sellers": "Sellers",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.guides": "Guides",
  "nav.safety": "Safety",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.categories": "Categories",
  "nav.cta": "Visit Main Website",

  "hero.badge": "Independent Buying Resource",
  "hero.title": "AllChinaBuy Spreadsheet — Discover Products, Sellers & Buying Guides",
  "hero.subtitle":
    "Explore organized AllChinaBuy spreadsheets, product finds, seller resources, QC guides, shipping information, reviews and practical buying tutorials — all in one place.",
  "hero.searchPlaceholder": "Search products, sellers, categories or AllChinaBuy guides…",
  "hero.ctaPrimary": "allchinabuy spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Independent buying resource • Updated content • Practical guides • Safety-focused research",

  "categories.label": "Browse by category",
  "categories.title": "Find What You Need Faster",
  "categories.subtitle":
    "Jump straight to the section of the main store you need — every category below opens the matching product list.",

  "featured.title": "Your Complete AllChinaBuy Spreadsheet Resource",
  "featured.subtitle":
    "Research first, then continue to the main website when you are ready. These guides cover the topics buyers ask about most.",
  "featured.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "featured.spreadsheet.desc":
    "Browse organized product resources and popular categories.",
  "featured.review.title": "AllChinaBuy Review",
  "featured.review.desc":
    "Understand the platform, costs, features, strengths and limitations.",
  "featured.shipping.title": "AllChinaBuy Shipping Cost",
  "featured.shipping.desc":
    "Learn how weight, dimensions, destination and shipping lines affect costs.",
  "featured.qc.title": "AllChinaBuy QC",
  "featured.qc.desc":
    "Understand QC photos, inspection and pre-shipping checks.",
  "featured.warehouse.title": "AllChinaBuy Warehouse",
  "featured.warehouse.desc":
    "Learn how warehouse storage, inspection and consolidation work.",
  "featured.safety.title": "AllChinaBuy Safety",
  "featured.safety.desc":
    "Learn how to identify fake websites, phishing attempts and risky sellers.",

  "searches.title": "Popular Searches",
  "searches.subtitle": "The questions and topics readers look up most often.",
  "searches.item1": "AllChinaBuy review",
  "searches.item2": "AllChinaBuy shipping cost",
  "searches.item3": "AllChinaBuy coupon",
  "searches.item4": "AllChinaBuy discount code",
  "searches.item5": "AllChinaBuy warehouse",
  "searches.item6": "AllChinaBuy legit",

  "why.title": "Why Use This Resource",
  "why.subtitle": "Built to make China buying clearer, safer and easier to compare.",
  "why.point1.title": "Organized categories",
  "why.point1.desc": "Every product type is grouped so you can find a realistic price range quickly.",
  "why.point2.title": "Original guides",
  "why.point2.desc": "Plain-language explanations written for real buyers, not recycled filler.",
  "why.point3.title": "Safety first",
  "why.point3.desc": "Practical advice on spotting fake sites, phishing and risky sellers.",
  "why.point4.title": "Straight to the store",
  "why.point4.desc": "Clear outbound links take you to the exact section you need, when you are ready.",

  "articles.title": "Latest Articles",
  "articles.subtitle": "Original, in-depth guides on the AllChinaBuy spreadsheet.",
  "articles.readMore": "Read the guide",
  "articles.cardTitle": "AllChinaBuy Spreadsheet: The Complete 2026 Guide",
  "articles.cardDesc":
    "Products, sellers, QC photos and shipping — how to organize every order in one clear, sortable sheet.",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers to the questions buyers ask most.",
  "faq.q1": "What is an AllChinaBuy spreadsheet?",
  "faq.a1":
    "It is a self-organized tracking sheet for orders placed through a China buying platform — listing products, sellers, prices, QC status and shipping details in one sortable view.",
  "faq.q2": "Is this the official AllChinaBuy website?",
  "faq.a2":
    "No. This is an independent informational resource with no official affiliation. For official information, always verify against the current platform directly.",
  "faq.q3": "Do I need a spreadsheet for small orders?",
  "faq.a3":
    "Not strictly, but a simple sheet still helps you compare total landed cost across sellers and keep QC and weight notes in one place.",
  "faq.q4": "Which categories can I browse here?",
  "faq.a4":
    "Shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes and more — each linking to the matching section of the main store.",

  "cta.title": "Ready to explore more?",
  "cta.text":
    "Use our guides to research first, then continue to the main website when you are ready.",
  "cta.button": "Go to Main Website",

  "footer.tagline": "The Complete Product, Seller, QC & Buying Resource",
  "footer.disclaimer":
    "This is an independent informational website and is not affiliated with or endorsed by AllChinaBuy. Prices, shipping and policies change — always verify against the current official platform.",
  "footer.resourcesTitle": "Resources",
  "footer.legalTitle": "Legal",
  "footer.languagesTitle": "Languages",
  "footer.about": "About",
  "footer.editorial": "Editorial Policy",
  "footer.safety": "Safety Center",
  "footer.disclaimerLink": "Disclaimer",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms",
  "footer.contact": "Contact",
  "footer.sitemap": "Sitemap",
  "footer.mainSite": "Main Website",
  "footer.rights": "All rights reserved.",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies / Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants / Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear / Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",

  "article.notFound": "Article not found",
  "article.summary": "Summary",
  "article.backHint": "Return to the homepage to browse all categories and guides.",

  "category.guide": "Guide",
  "category.review": "Review",
  "category.safety": "Safety",
  "category.shipping": "Shipping",
  "category.warehouse": "Warehouse",
  "category.qc": "QC",
  "category.coupons": "Coupons",
  "category.comparison": "Comparison",
  "category.beginners": "Beginners",
};